import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getFinancialUser(params) {
  return request({
    url: '/GetFinancialUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111111,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        KeyWord: params.keyWord,
        IsExport: params.IsExport,
        Country: params.country,
        SortOrder: params.SortOrder,
        CompanyProvince: params.CompanyProvince,
        LastCRMUpdateTime: params.LastCRMUpdateTime,
        Type: params.Type,
        IsRegistered: params.IsRegistered,
        UserID: params.UserID
      }
    }
  })
}

export function getFinancialAppeal(params) {
  return request({
    url: '/GetFinancialAppeal',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111112,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        UserID: params.UserID,
        AdminID: params.AdminID,
        Keywords: params.keyWord,
        Type: params.Type,
        IsRegistered: params.IsRegistered
      }
    }
  })
}

export function deleteFinancialAppeal(params) {
  return request({
    url: '/DeleteFinancialAppeal',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111113,
      MessageID: btcguid(),
      Data: {
        FinancialID: params.FinancialID
      }
    }
  })
}

export function getFinancialCrm(params) {
  return request({
    url: '/GetFinancialCrm',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111114,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID
      }
    }
  })
}

export function addFinancialCrm(params) {
  return request({
    url: '/AddFinancialCrm',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111115,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID,
        CompanyType: params.CompanyType,
        HasQualification: params.HasQualification,
        HasImportsAndExportsDate: params.HasImportsAndExportsDate,
        RegisterUserDutie: params.RegisterUserDutie,
        RelatedPlaceOfProduction: params.RelatedPlaceOfProduction,
        PhoneNumber: params.PhoneNumber,
        WeiXinNumber: params.WeiXinNumber,
        CustomerAppraise: params.CustomerAppraise,
        CompanyName: params.CompanyName,
        Province: params.Province,
        RoleInBtc: params.RoleInBtc,
        ContactPerson: params.ContactPerson
      }
    }
  })
}

export function updateFinancialCrm(params) {
  return request({
    url: '/UpdateFinancialCrm',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111116,
      MessageID: btcguid(),
      Data: {
        FinancialCrmID: params.FinancialCrmID,
        CompanyType: params.CompanyType,
        HasQualification: params.HasQualification,
        HasImportsAndExportsDate: params.HasImportsAndExportsDate,
        RegisterUserDutie: params.RegisterUserDutie,
        RelatedPlaceOfProduction: params.RelatedPlaceOfProduction,
        PhoneNumber: params.PhoneNumber,
        WeiXinNumber: params.WeiXinNumber,
        CustomerAppraise: params.CustomerAppraise,
        CompanyName: params.CompanyName,
        Province: params.Province,
        RoleInBtc: params.RoleInBtc,
        ContactPerson: params.ContactPerson
      }
    }
  })
}

export function getFinancialContactDetail(params) {
  return request({
    url: '/GetFinancialContactDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111117,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        FinancialID: params.FinancialID,
        CompanyID: params.companyID
      }
    }
  })
}

export function addFinancialContactDetail(params) {
  return request({
    url: '/AddFinancialContactDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111118,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID,
        FinancialID: params.FinancialID,
        ContactDateTime: params.ContactDateTime,
        ContactPerson: params.ContactPerson,
        ContactWay: params.ContactWay,
        ContactContent: params.ContactContent,
        ContactKey: params.ContactKey,
        Origin: params.Origin,
        PlantNo: params.PlantNo,
        Cuts: params.Cuts,
        Quantity: params.Quantity,
        ContactLevel: params.ContactLevel
        // CanModify: params.CanModify
      }
    }
  })
}

export function updateFinancialContactDetail(params) {
  return request({
    url: '/UpdateFinancialContactDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111119,
      MessageID: btcguid(),
      Data: {
        ContactID: params.ContactID,
        CompanyID: params.CompanyID,
        FinancialID: params.FinancialID,
        ContactDateTime: params.ContactDateTime,
        ContactPerson: params.ContactPerson,
        ContactWay: params.ContactWay,
        ContactContent: params.ContactContent,
        ContactKey: params.ContactKey,
        ContactLevel: params.ContactLevel,
        Origin: params.Origin,
        PlantNo: params.PlantNo,
        Cuts: params.Cuts,
        Quantity: params.Quantity,
        CanModify: params.CanModify
      }
    }
  })
}

export function getFinancialAggregate(params) {
  return request({
    url: '/GetFinancialAggregate',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111120,
      MessageID: btcguid(),
      Data: {
        IsRegister: params.IsRegister,
        Origin: params.Origin,
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        PlantNo: params.PlantNo,
        Cuts: params.Cuts
      }
    }
  })
}

export function emptyFinancialManage(params) {
  return request({
    url: '/EmptyFinancialManage',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111121,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        Type: params.Type,
        IsRegistered: params.IsRegistered
      }
    }
  })
}

export function updateFinancialContactMark(params) {
  return request({
    url: '/UpdateFinancialContactMark',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111122,
      MessageID: btcguid(),
      Data: {
        ContactID: params.ContactID,
        Mark: params.Mark
      }
    }
  })
}

export function getPurchaseAndSaleUser(params) {
  return request({
    url: '/GetPurchaseAndSaleUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111123,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        KeyWord: params.keyWord,
        IsExport: params.IsExport,
        Country: params.country,
        SortOrder: params.SortOrder,
        CompanyProvince: params.CompanyProvince,
        LastCRMUpdateTime: params.LastCRMUpdateTime,
        Type: params.Type,
        IsRegistered: params.IsRegistered,
        UserID: params.UserID
      }
    }
  })
}

export function getPurchaseAndSalesContactDetail(params) {
  return request({
    url: '/GetPurchaseAndSalesContactDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111124,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        CompanyID: params.companyID
      }
    }
  })
}

export function addPurchaseAndSalesContactDetail(params) {
  return request({
    url: '/AddPurchaseAndSalesContactDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111125,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID,
        PurchaseAndSalesID: params.PurchaseAndSalesID,
        ContactDateTime: params.ContactDateTime,
        ContactPerson: params.ContactPerson,
        ContactWay: params.ContactWay,
        ContactContent: params.ContactContent,
        ContactKey: params.ContactKey,
        Origin: params.Origin,
        PlantNo: params.PlantNo,
        Cuts: params.Cuts,
        Quantity: params.Quantity,
        ContactLevel: params.ContactLevel
        // CanModify: params.CanModify
      }
    }
  })
}

export function updatePurchaseAndSalesContactDetail(params) {
  return request({
    url: '/UpdatePurchaseAndSalesContactDetail',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111126,
      MessageID: btcguid(),
      Data: {
        ContactID: params.ContactID,
        CompanyID: params.CompanyID,
        FinancialID: params.FinancialID,
        ContactDateTime: params.ContactDateTime,
        ContactPerson: params.ContactPerson,
        ContactWay: params.ContactWay,
        ContactContent: params.ContactContent,
        ContactKey: params.ContactKey,
        ContactLevel: params.ContactLevel,
        Origin: params.Origin,
        PlantNo: params.PlantNo,
        Cuts: params.Cuts,
        Quantity: params.Quantity,
        CanModify: params.CanModify
      }
    }
  })
}

export function getPurchaseAndSalesCrm(params) {
  return request({
    url: '/GetPurchaseAndSalesCrm',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111127,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID
      }
    }
  })
}

export function addPurchaseAndSalesCrm(params) {
  return request({
    url: '/AddPurchaseAndSalesCrm',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111128,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID,
        CompanyType: params.CompanyType,
        HasQualification: params.HasQualification,
        HasImportsAndExportsDate: params.HasImportsAndExportsDate,
        RegisterUserDutie: params.RegisterUserDutie,
        RelatedPlaceOfProduction: params.RelatedPlaceOfProduction,
        PhoneNumber: params.PhoneNumber,
        WeiXinNumber: params.WeiXinNumber,
        CustomerAppraise: params.CustomerAppraise,
        CompanyName: params.CompanyName,
        Province: params.Province,
        RoleInBtc: params.RoleInBtc,
        ContactPerson: params.ContactPerson
      }
    }
  })
}

export function updatePurchaseAndSalesCrm(params) {
  return request({
    url: '/UpdatePurchaseAndSalesCrm',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111129,
      MessageID: btcguid(),
      Data: {
        FinancialCrmID: params.FinancialCrmID,
        CompanyType: params.CompanyType,
        HasQualification: params.HasQualification,
        HasImportsAndExportsDate: params.HasImportsAndExportsDate,
        RegisterUserDutie: params.RegisterUserDutie,
        RelatedPlaceOfProduction: params.RelatedPlaceOfProduction,
        PhoneNumber: params.PhoneNumber,
        WeiXinNumber: params.WeiXinNumber,
        CustomerAppraise: params.CustomerAppraise,
        CompanyName: params.CompanyName,
        Province: params.Province,
        RoleInBtc: params.RoleInBtc,
        ContactPerson: params.ContactPerson
      }
    }
  })
}

export function getAgentUserCircle(params) {
  return request({
    url: '/GetAgentUserCircle',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111130,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        UserID: params.UserID,
        Type: params.Type
      }
    }
  })
}

export function getPurchaseAndSaleAggregate(params) {
  return request({
    url: '/GetPurchaseAndSaleAggregate',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111131,
      MessageID: btcguid(),
      Data: {
        Origin: params.Origin,
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        PlantNo: params.PlantNo,
        Cuts: params.Cuts
      }
    }
  })
}

export function deleteFinancialAllAppeal(params) {
  return request({
    url: '/DeleteFinancialAllAppeal',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111132,
      MessageID: btcguid(),
      Data: {
        UserID: params.LoginUserName,
        Type: params.Type
      }
    }
  })
}

export function updatePurchaseAndSaleContactMark(params) {
  return request({
    url: '/UpdatePurchaseAndSaleContactMark',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111133,
      MessageID: btcguid(),
      Data: {
        ContactID: params.ContactID,
        Mark: params.Mark
      }
    }
  })
}

export function addAdminUsers(params) {
  return request({
    url: '/AddAdminUsers',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 1111134,
      MessageID: btcguid(),
      Data: {
        CompanyID: params.CompanyID,
        FinancialID: params.FinancialID,
        UserID: params.UserID,
        IsFinancial: params.IsFinancial
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/financial.js